<template>
  <o-form-group v-if="msg && msg.hasMessage">
    <b-input-group>
      <b-alert show :variant="msg.variant" dismissible @dismissed="msg = null">
        {{ msg.message }}
      </b-alert>
    </b-input-group>
  </o-form-group>
</template>

<script>
export default {
  name: "CheckLeaveLimits",
  props: {
    employeeId: {
      type: [String, Number, null],
      required: true,
    },
    startDate: {
      type: [String, null],
      required: false,
    },
    endDate: {
      type: [String, null],
      required: false,
    },
  },
  data() {
    return {
      msg: { hasMessage: false },
    };
  },
  watch: {
    // Watch for any changes in employeeId, startDate, or endDate and trigger the API call
    employeeId: "checkLeaveLimit",
    startDate: "checkLeaveLimit",
    endDate: "checkLeaveLimit",
  },
  methods: {
    async checkLeaveLimit() {
      if (!this.employeeId || !this.startDate || !this.endDate) {
        this.msg.hasMessage = false; // Reset message if inputs are empty
        return;
      }

      try {
        const response = await this.axios.post("/api/check_leave_limit/", {
          employee_id: this.employeeId,
          start_date: this.startDate,
          end_date: this.endDate,
        });

        if (response.data) {
          this.msg = response.data;
        }
      } catch (error) {
        console.error("API error:", error);
      }
    },
  },
  created() {
    this.checkLeaveLimit();
  },
};
</script>

<style scoped>
/* Add any relevant styles if needed */
</style>
